<template>
  <div class="item">
    <span class="checkbox">
      <input
        type="checkbox"
        name="chk_control"
        :id="`control_${item.spacetypeid}_${item.subtype}`"
        :checked="checked"
        @change="onChecked">
      <label :for="`control_${item.spacetypeid}_${item.subtype}`"></label>
    </span>
    <router-link :to="{name: 'controlItem', params: {id: item.spacetypeid, subtype: item.subtype}}" class="spacetype">
      <p class="label">{{item.spacetypeid}}
        <span v-if="item.subtype !== '0'">- {{item.subtype}}</span>
      </p>
      <div v-if="item.subtype === '0'" class="property">
        <span
          v-for="item in property"
          :key="item"
          :data-property="item"
          :title="item">{{propertyCnt(item)}}</span>
      </div>
      <div v-else class="property"></div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'item',
    'isChkAll'
  ],
  computed: {
    property () {
      return Object.keys(this.item.property)
    },
    checked () {
      return this.isChkAll
    }
  },
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    propertyCnt (key) {
      const property = this.item.property[key]
      return Object.keys(property).length
    },
    onChecked (e) {
      const data = {
        spaceid: this.item.spacetypeid,
        subtype: this.item.subtype,
        isChecked: e.target.checked
      }
      this.$emit('checkedItem', data)
    }
  }
}
</script>
